module.exports = __webpack_public_path__ + "img/ryouri-tyou.96d112d4.png";